import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { NoteSearchService, SearchResponse } from 'src/app/service/search/note-search.service';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'note-search',
  templateUrl: './note-search.component.html',
  styleUrls: ['./note-search.component.scss']
})
export class NoteSearchComponent {
  constructor(private service: NoteSearchService, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer) { }
  searchTerm: string = '';
  searchResults: SearchResponse | null = null;
  loading: boolean = false;
  errorMessage: string = '';
  hasSearched: boolean = false;

  searchDocuments() {
    this.hasSearched = true;
    this.loading = true;
    this.errorMessage = '';

    if (this.searchTerm) {
      this.service.searchDocument(this.searchTerm).subscribe(
        {
          next: (res) => {
            res.summary = this.sanitizer.bypassSecurityTrustHtml(res.summary as string)
            this.searchResults = res;
            this.loading = false;
          },
          error: (err: HttpErrorResponse) => {
            this.errorMessage = err.message;
            this.searchResults = null;
            this.loading = false;
          }
        });
    } else {
      this.searchResults = null;
      this.loading = false;
    }
  }
}
